import styled from "@emotion/styled";
import { ICommand, RelayCommand, theme } from "Application";
import { Box, Button, Input } from "Components";
import { CloseIcon } from "Styles/ThemedPrimitives/Style1/CloseIcon";
import { ThemedEditSelect } from "Styles/ThemedPrimitives/Style1/ThemeEditSelect";
import React from "react";
import { Files } from "Views/Students/Student/StudentReports/Files/Files";
import { StudentSessionAQACertificateViewModel } from "../Shared/StudentSessionAQACertificateViewModel";
import { ViewMode } from "Views/Shared/Interfaces/IViewMode";

const Container = styled.div`
    padding: 25px 20px;
`;

const Footer = styled.div``;

const ButtonGroup = styled.div`
    padding: 30px 0 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px 30px;
    Button {
        width: 100%;
        margin-bottom: 0;
        height: 40px;
        border-radius: 5px;
    }
`;

const StyledDialog = styled.dialog`
    max-width: 400px;
    width: calc(100% - 50px);
    padding: 0;
    background: ${theme.palette.common.white};
    box-shadow: 0 0 5px rgba(101, 110, 119, 0.2);
    border: 0;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    &:focus {
        border: none;
        outline: none;
    }

    &::backdrop {
        background: rgba(224, 228, 232, 0.9);
        animation: 0.4s ease fade;
    }

    &[open] {
        animation: 0.2s linear slidein;
    }

    @keyframes slidein {
        from {
            transform: translate3d(0, 5px, 0) translate(-50%, -50%);
        }
        to {
            transfrom: translate3d(0, 0, 0) translate(-50%, -50%);
        }
    }

    @keyframes fade {
        from {
            opacity: 0.3;
        }
        to {
            opacity: 1;
        }
    }
`;

const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fcd21d;
    padding: 12px 20px;
    font: normal normal bold 18px/24px Open Sans;
    letter-spacing: 0px;
    color: #000000;
    font-family: OpenSans-CondBold;
    button {
        width: auto !important;
        height: auto !important;
        min-height: auto;
    }
`;

const CreateBox = styled.div`
    & > div .isButtonDisable {
        cursor: default;
        color: #495057;
        background-color: #e9ecef;
    }
`;

export interface IProps {
    viewModel: StudentSessionAQACertificateViewModel | null;
    onConfirmCommand: ICommand;
    onCloseCommand: ICommand;
}

export const AddEditAQAStudentSessionModal: React.FC<IProps> = ({ onCloseCommand, onConfirmCommand, viewModel }) => {
    if (!viewModel) return <></>;

    const title = viewModel!.viewMode.isAddMode ? "Add AQA Certificate" : "Edit AQA Certificate";
    const addEditButtonDisplayName = viewModel!.viewMode.isAddMode ? "Add" : "Update";
    return (
        <>
            <StyledDialog open={true}>
                <Header>
                    {title} <CloseIcon onClick={() => onCloseCommand.execute()} />
                </Header>
                <Container>
                    <Input
                        multiline={true}
                        displayName={"What was the AQA Certificate?"}
                        value={() => viewModel.getValue("description")}
                        command={viewModel.updateDescriptionCommand}
                        placeholder={"Please add notes..."}
                        rows={4}
                        isRequired={false}
                        showClearText={!viewModel.isMobile}
                    />{" "}
                    <Footer>
                        <CreateBox>
                            <ButtonGroup>
                                <Button command={onConfirmCommand} displayName={addEditButtonDisplayName} paletteColor="primary" />
                                <Button command={onCloseCommand} displayName={"CANCEL"} paletteColor="secondary" />
                            </ButtonGroup>
                        </CreateBox>
                    </Footer>
                </Container>
            </StyledDialog>
        </>
    );
};
